import type { ICirrusReaderCombinedTheme, ICirrusReaderPublicationStylePalette, ICirrusReaderUiColorTheme, ICirrusReaderFontSetAsset } from "../shared/CirrusReaderModel";
import type { LatestConfig } from "../../../../app/configuration/schemas";

export const useApplyCirrusConfig = () => {
    const generateFullConfiguration = (customConfig: LatestConfig): LatestConfig => {
        console.info(`Generating Full Config by Patching\n`, customConfig);
        const cirrusConfigStore = useCirrusConfigStore();
        cirrusConfigStore.$patch({
            config: {
                ...cirrusConfigStore.config,
                ...customConfig,
            },
        });

        if (cirrusConfigStore.config.plan !== 'free'){
            //Replace Default Theme UI with UI Theme provided by the customer in their configuration.
            if (typeof cirrusConfigStore.config?.public.theme ===  'object') useCirrusReaderSettingsStore().availableThemes[0] = {...useCirrusReaderSettingsStore().availableThemes[0], ...(cirrusConfigStore.config?.public.theme as object) } as ICirrusReaderCombinedTheme
            applyCirrusTheme(cirrusConfigStore.config?.public.theme);
            
            if ('fonts' in cirrusConfigStore.config.public) {
                if (Array.isArray(cirrusConfigStore.config.public.fonts)) {
                    useCirrusReaderSettingsStore().setAvailableFonts(cirrusConfigStore.config.public.fonts as ICirrusReaderFontSetAsset[]);
                } else {
                    useCirrusReaderSettingsStore().setAvailableFonts([cirrusConfigStore.config.public.fonts] as ICirrusReaderFontSetAsset[]);
                }
            }
        }

        if (cirrusConfigStore.config.public.renderers) {
            useCirrusReaderSettingsStore().setAvailableRenderers(cirrusConfigStore.config.public.renderers);
        }

        return cirrusConfigStore.config;
    }

    const applyCirrusTheme = (theme: string | ICirrusReaderUiColorTheme | ICirrusReaderPublicationStylePalette) => {
        if (theme == null || typeof theme === 'undefined') return;
        if (typeof theme === 'string') {
            _applyNamedTheme(theme);
        } else if ("name" in theme) {
            _applyNamedTheme(theme['name']);
        } else {
            _applyNamedTheme("Default");
        }
    }    

    const _applyNamedTheme = (theme: string) => {
        console.info(`Applying a named Theme: ${theme}`);
        const palette = useCirrusReaderSettingsStore().availableThemes.filter((colorTheme) => colorTheme.name.toLowerCase() == theme.toLowerCase())[0];
        if (palette){
            useCirrusReaderSettingsStore().setTheme(palette);
            useHead({
                htmlAttrs: {
                    style: `
                    --ui-bg: ${palette.uiBackgroundLight};
                    --ui-bg-translucent: ${useAccessibleColors().opacity(palette.uiBackgroundLight, 0)};
                    --ui-text: ${palette.uiForegroundDark};
                    --ui-text-default: ${palette.uiForegroundDark};
                    --ui-text-muted: ${palette.uiForegroundDark};
                    --ui-text-highlighted: ${palette.uiForegroundDark};
                    --ui-primary: ${palette.uiForegroundDark};
                    --ui-bg-elevated: ${useAccessibleColors().contrast(palette.uiBackgroundLight, 25)};
                    --ui-bg-inverted: ${useAccessibleColors().contrast(palette.uiBackgroundLight, 25)};
                    --ui-bg-accented: ${useAccessibleColors().contrast(palette.uiBackgroundLight, 25)};
                    --ui-text-inverted: ${palette.uiForegroundDark};
                    `
                }
            });
        }
    }
   
    return {
        generateFullConfiguration,
        applyCirrusTheme,
    }
}

